import Footer from "./Footer";
import Header from "./Header";
import { images } from "../../common/Images";
import "../../styles/Favourites.css";
import { ApiCall, Web_url, Colors } from "../../common/Const";
import React, { useState, useEffect } from "react";
import FavoriteBan from "./FavoriteBan";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import store from "../../redux/Store";

function Favourites() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const RdxCart = useSelector((state) => state.cart);
  const [alreadyinCart, setalreadyinCart] = useState(false);

  const [fav, setFav] = useState([]);
  useEffect(() => {
    favlist();
    store.dispatch({ type: "ClearMenu" });
    store.dispatch({ type: "ClearParams" });
    store.dispatch({ type: "ClearSort" });
  }, []);

  const favlist = () => {
    ApiCall("favView", {
      customer_id: user && user.id > 0 && user.id,
      page_number: 0,
    })
      .then((data) => {
        store.dispatch({type: 'addfavCount', payload: data.fav_total_count})
        if (data.message === "Success.") {
          setFav(data.result);
          
        } else {
          setFav([]);
        }
      })
      .catch((err) => console.log(err));
  };
  const removeFav = (product_id) => {
    ApiCall("removeFav", {
      customer_id: user && user.id > 0 && user.id,
      product_id: product_id,
    })
      .then((data) => {
        if (data.message === "Success") {
          favlist();
        }
      })
      .catch((err) => console.log(err));
  };

  //   useEffect(() => {
  //     isInCart();
  //   }, [RdxCart]);

  //   console.log(fav.product_id);
  const checkIsCart = (data) => {
    let cartarr = Object.values(RdxCart).filter((val) => {
      // console.log(val.product_id);
      if (
        val.product_id == data.product_id &&
        val.order_sizes == data.varient[0].size &&
        val.karat == data.varient[0].karat
      ) {
        return true;
      } else {
        return false;
      }
    });
    console.log(cartarr);
    if (cartarr.length == 1) {
      return true;
    } else {
      return false;
    }

    //  cartarr.length === 1 ?  : setalreadyinCart(false);
  };

  //   console.log(fav);
  async function additemtoCart(val) {
    console.log(val);

    var data = fav.filter((data) => data.product_id == val);

    // console.log(data[0]);
    store.dispatch({
      type: "addToCart",
      payload: {
        product_id: data[0].product_id,
        product_name: data[0].product_name,
        product_image: data[0].product_image,
        order_sizes: data[0].varient[0].size,
        karat: data[0].varient[0].karat,
        weight: data[0].varient[0].weight,
        order_price: data[0].varient[0].offer_price,
        // varient: varientname,
        variant_id: data[0].varient[0].id,
        packing_charges: data[0].packing_charges,
      },
    });
  }
  console.log(RdxCart);

  const handleClick = (data) => {
    console.log("---->", data);
    navigate("/product-details", { state: { p_detail: data } });
  };
  return (
    <>
      <Header make={true} />
      {/* <FavoriteBan /> */}
      <div className="list pb-5">
        <div className="container pb-2">
          <div className="row">
            <div className="col-xl-4 col-lg-4 col-10 mt-5 p-0">
              <h4 className="fav-head">
                My Wishlists&nbsp;&nbsp;
                <span>
                  <i
                    className="fa-solid fa-heart seller-heart mt-3"
                    style={{ color: Colors.Base_color }}
                  ></i>
                </span>
              </h4>
            </div>
          </div>
        </div>
        {fav.length > 0 ? (
          fav.map((favlis, index) => {
            return (
              <div className="container mt-3">
                <div className="row list-item">
                  <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-4  p-0">
                    <img role={"button"} onClick={() => handleClick(favlis)}
                      src={Web_url.Domain_url + favlis.product_image[0].url}
                      alt="Fav"
                      className="list-img"
                      width="145"
                      height="130"
                    ></img>
                  </div>
                  <div
                    className="col-xl-10 col-lg-9 col-md-9 col-sm-8 col-8 p-0"
                  >
                    <div className="d-flex justify-content-between list1">
                      <p role={"button"} onClick={() => handleClick(favlis)} className="item-name mb-0">{favlis.product_name}</p>
                      <div>
                        <i
                          onClick={(e) => removeFav(favlis.product_id)}
                          className="fa-solid fa-close close-btn px-2 py-1"
                          style={{ color: Colors.Base_color }}
                        ></i>
                      </div>
                    </div>

                    <p className="collect-name mb-0">
                      <span>Collections : </span>
                      {favlis.collection_name}
                    </p>

                    <p className="offer-rate mb-0">
                      Rs. ₹&nbsp;{favlis.product_price}
                    </p>
                    <div className="d-flex justify-content-between">
                      <p className="origin-rate mb-0">
                        Rs. ₹&nbsp;{favlis.varient[0].actual_price}
                      </p>
                      {checkIsCart(favlis) === false ? (
                        <button
                          type="button"
                          className="btn add-bag rounded"
                          value={favlis.product_id}
                          style={{
                            color: Colors.white_color,
                            backgroundColor: Colors.Base_color,
                          }}
                          onClick={(e) => additemtoCart(e.target.value)}
                        >
                          Add to Bag
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="btn add-bag rounded"
                          style={{
                            color: Colors.white_color,
                            backgroundColor: Colors.Base_color,
                          }}
                          onClick={() => navigate("/mycart")}
                        >
                          View cart
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="text-center">You have no products in wishlist!</div>
        )}
      </div>
      <Footer />
    </>
  );
}

export default Favourites;
